import { getcolumns } from "./utilities";
import { useTranslation } from "react-i18next";
import FilterComponent from "./FilterComponent";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { allSharedComponents } from "../../../../shared";
import { boatTypeActions } from "../../../../redux/actions";
import {
  changeTableSortIcons,
  getSortDirectionProperty,
} from "../../../../system";
import {
  Directions,
  modeConstants,
  translationConstants,
} from "../../../../constants";
import CustomModal from "../../../../shared/components/CustomModal/CustomModal";
import AddBoatClass from "./Modal/AddBoatClass";
import DeleteModal from "../../../../shared/components/Modals/DeleteModal";

const { DataTable } = allSharedComponents;

let sortingInProgress = false;
const defaultQueryExpression = "id != null ";

const initialGridState = {
  length: 10,
  search: "",
  pageNumber: 1,
  orderBy: "id desc",
  filterQuery: defaultQueryExpression,
};

const BoatClasses = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const boatClassesData = useSelector(
    (state) => state.BoatTypeReducer.boatClassesData
  );
  const direction = useSelector((state) => {
    return state.LanguageChangeReducer.direction;
  });

  const [rowData, setRowData] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [gridState, setGridState] = useState(initialGridState);
  const [defaultPage, setDefaultPage] = useState(gridState.pageNumber);
  const [modalMode, setModalMode] = useState(modeConstants.ADD_MODE);
  const [isShowModal, setShowModal] = useState(false);
  const [isShowDeleteModal, setShowDeleteModal] = useState(false);
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [boatClassToDelete, setBoatClassToDelete] = useState("");

  const getRowData = (row) => {
    dispatch(boatTypeActions.getBoatClassById(row.id));
    setShowModal(true);
  };

  const removeRowData = (data) => {
    dispatch(
      boatTypeActions.deleteBoatClassById(data.id, () => {
        setShowDeleteModal(false);
      })
    );
  };

  const onDelete = (row) => {
    setTitle(t(translationConstants.DELETE_A_BOAT_CLASS));
    setMessage(
      `${t(translationConstants.ARE_YOU_SURE)} ${
        direction === Directions.rtl && row?.arabicName
          ? row?.arabicName
          : row?.name
      } ${t(translationConstants.FROM_BOAT_CLASS_LIST)}`
    );
    setBoatClassToDelete(row);
    setShowDeleteModal((prev) => !prev);
  };

  const [columns, setColumns] = useState(
    getcolumns(t, direction, setModalMode, getRowData, onDelete)
  );

  useEffect(() => {
    setColumns(getcolumns(t, direction, setModalMode, getRowData, onDelete));
    // eslint-disable-next-line
  }, [i18n.dir()]);

  useEffect(() => {
    dispatch(boatTypeActions.getAllBoatClass(gridState));
    sortingInProgress = false;
    // eslint-disable-next-line
  }, [gridState]);

  useEffect(() => {
    setRowData(boatClassesData?.pageData);
    setTotalRows(boatClassesData?.page?.totalElements);
    // eslint-disable-next-line
  }, [boatClassesData]);

  const onChangePage = (pageNumber) => {
    if (!sortingInProgress) {
      setGridState((prevState) => ({
        ...prevState,
        pageNumber: pageNumber,
      }));
    }
  };

  const onChangeRowsPerPage = (newPerPage, pageNumber) => {
    setGridState((prevState) => ({
      ...prevState,
      length: newPerPage,
      pageNumber: pageNumber,
    }));
  };

  const onSort = (sortedColumn) => {
    sortingInProgress = true;
    setColumns(changeTableSortIcons(columns, sortedColumn));
    const columnDirection = getSortDirectionProperty(sortedColumn);
    setDefaultPage(gridState.pageNumber);
    setGridState({
      ...gridState,
      orderBy: columnDirection
        ? `${sortedColumn.id} ${columnDirection}`
        : "id desc",
    });
  };

  return (
    <div className="UserDiv">
      <div>
        <p className="UserTabHeading">{t(translationConstants.BOAT_CLASSES)}</p>
        <div className="tableContainer">
          <FilterComponent
            gridState={gridState}
            setGridState={setGridState}
            setModalMode={setModalMode}
            setShowModal={setShowModal}
            defaultQueryExpression={defaultQueryExpression}
          />

          <DataTable
            onSort={onSort}
            items={rowData}
            columns={columns}
            gridState={gridState}
            paginationResetDefaultPage
            onChangePage={onChangePage}
            paginationTotalRows={totalRows}
            paginationDefaultPage={defaultPage}
            onChangeRowsPerPage={onChangeRowsPerPage}
          />
        </div>
      </div>

      {isShowModal && (
        <CustomModal
          size="lg"
          scrollable
          show={isShowModal}
          setShow={setShowModal}
          customClass="view-user-modal"
          closeOnOutsideClick={modalMode === modeConstants.VIEW_MODE}
        >
          <AddBoatClass
            mode={modalMode}
            gridState={gridState}
            setShowModal={setShowModal}
          />
        </CustomModal>
      )}

      {isShowDeleteModal && (
        <CustomModal
          scrollable={true}
          size="md"
          setShow={onDelete}
          show={isShowDeleteModal}
          customClass="view-user-modal"
        >
          <DeleteModal
            title={title}
            message={message}
            dataToDelete={boatClassToDelete}
            removeRowData={removeRowData}
            onCancel={() => setShowDeleteModal((prev) => !prev)}
          />
        </CustomModal>
      )}
    </div>
  );
};

export default BoatClasses;
